import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import StoryViewer from './StoryViewer';
import StoryCreator from './StoryCreator';
import '../../styles/stories.css';

export default function StoriesBar() {
  const [userStories, setUserStories] = useState([]);
  const [viewingStories, setViewingStories] = useState(null);
  const [viewingIndex, setViewingIndex] = useState(0);
  const [showCreator, setShowCreator] = useState(false);
  const [loading, setLoading] = useState(true);
  const [myAvatar, setMyAvatar] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem('trandi-auth') || '{}';
      setMyAvatar(JSON.parse(raw)?.state?.user?.avatarUrl || null);
    } catch (e) {
      setMyAvatar(null);
    }
    fetchStories();
  }, []);

  const fetchStories = async () => {
    try {
      const res = await api.get('/stories');
      setUserStories(res.data);
    } catch (err) {
      console.error('Failed to fetch stories:', err);
    }
    setLoading(false);
  };

  const handleCreateStory = async (formData) => {
    try {
      await api.post('/stories', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setShowCreator(false);
      fetchStories();
    } catch (err) {
      console.error('Failed to create story:', err);
    }
  };

  const handleDeleteStory = async (storyId) => {
    try {
      await api.delete(`/stories/${storyId}`);
      fetchStories();
    } catch (err) {
      console.error('Failed to delete story:', err);
    }
  };

  if (loading) return null;

  return (
    <div className="stories-bar">
      <div className="stories-scroll">
        <div className="story-item create-story" onClick={() => setShowCreator(true)}>
          <div className="story-avatar-wrapper create">
            <img src={myAvatar || '/cat.svg'} alt="" className="story-avatar" onError={(e) => { e.target.onerror = null; e.target.src = '/cat.svg'; }} />
            <div className="create-story-plus">+</div>
          </div>
          <span className="story-name">Ваша история</span>
        </div>
        {userStories.map((group) => (
          <div key={group.userId} className="story-item"
            onClick={() => { setViewingStories(group.stories); setViewingIndex(0); }}>
            <div className="story-avatar-wrapper has-story">
              <img src={group.userAvatarUrl || '/cat.svg'} alt="" className="story-avatar" onError={(e) => { e.target.onerror = null; e.target.src = '/cat.svg'; }} />
            </div>
            <span className="story-name">{group.userDisplayName}</span>
          </div>
        ))}
      </div>
      {viewingStories && (
        <StoryViewer stories={viewingStories} startIndex={viewingIndex}
          onClose={() => setViewingStories(null)}
          onDelete={handleDeleteStory}
          onIndexChange={setViewingIndex} />
      )}
      {showCreator && (
        <StoryCreator onClose={() => setShowCreator(false)} onCreate={handleCreateStory} />
      )}
    </div>
  );
}
